import React, { useContext, useState, useEffect, useRef } from "react"
import Context from "../utils/Context"
import { sendTaskToRobot, cancelActions, sendJourney } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faGamepad, faCog, faListOl, faCompass, faDolly, faChargingStation, faThList, faMinusCircle, faPlay, faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../components/ShowMessage"
import JoystickManual from "../components/JoystickManual"
import api from "../api/api"
import ROSLIB from "roslib"

export default function FoodLabMenu() {

    const context = useContext(Context)

    const positionRef = useRef()
    const mainTimer = useRef()
    const secTimer = useRef()
    const interactionRef = useRef()
    const followFlag = useRef()
    const inceptionRef = useRef()
    const firstRun = useRef()

    const [journey, setJourney] = useState()
    const [people, setPeople] = useState(0)
    //const [interaction, setInteraction] = useState(false)
    const [selectedMenu, setSelectedMenu] = useState("store")
    const [inceptionFlag, setInceptionFlag] = useState(false)
    const [counter, setCounter] = useState(0)

    const [journeyBlocker, setJourneyBlocker] = useState([false, false, false])
    const [timerBlocked, setTimerBlocked] = useState(false)
    const [timerCount, setTimerCount] = useState(0)

    // on start, save it in flag and check what was the last journey the robot was left on
    useEffect(() => {
        //followFlag.current = false
        firstRun.current = true
        journeyCheck()
    }, [])

    // checks last journey the robot was left on
    const journeyCheck = async () => {
        let res

        let blocker = []

        if (window.ros) {
            const taskManager = new ROSLIB.Topic({
                ros: window.ros && window.ros,
                name: "/wgo/task_manager/TaskFeedback",
                messageType: "custom_msgs/TaskFeedback",
            })

            // subscribes to task manager to see what the last journey was
            taskManager.subscribe((message) => {
                context.actions.setEndOfMission(message)

                if (Number(message.name.slice(8)) !== journey) {
                    setJourney(Number(message.name.slice(8)))
                }
            })

            const interaction = new ROSLIB.Topic({
                ros: window.ros && window.ros,
                name: "/wgo/user_interaction/person_in_front",
                messageType: "std_msgs/Int8",
            })

            // checks to see if people are interacting to show the remote user
            interaction.subscribe((message) => {
                //console.log(message)

                if (message !== people) setPeople(message.data)
            })
        }

        /*try {
            res = await api.fetchJourney({})

            //console.log('CURRENT JOURNEY:', res.data, followFlag)

            if (res.data) {
                interactionRef.current = res.data?.interaction
                if (res.data?.journey > 3 && !followFlag.current) {
                    blocker = [true, true, true]
                    followFlag.current = true
                    setJourneyBlocker(blocker)
                    setCounter(0)
                    inceptionRef.current = false
                    clearTimeout(secTimer.current)

                    cancelActions({ stopAll: true })
                    let string = {
                        "robot": "FoodLab",
                        "mapIndex": 0,
                        "name": "FollowMe",
                        "actions": [
                            {
                                "id": "go-to",
                                "name": "go-to",
                                "needsValue": true,
                                "value": "FL_A"
                            },
                            {
                                "id": "orientate-to",
                                "name": "orientate-to",
                                "needsValue": true,
                                "value": "FL_A_ORIENTATE"
                            }
                        ],
                    }

                    context.actions.setCurrentMission(string)

                    positionRef.current = 'FL_A'
                    startTask(string)
                    setJourney(res.data.journey)
                }
            }
        } catch (err) {
            console.error(err)
        } finally {
            setTimeout(journeyCheck, 1000)
        }*/
    }

    // blocks buttons depending on what journey it's on to avoid redundancy
    useEffect(() => {
        let blocker = []
        switch (journey) {
            case 1:
                blocker = [true, false, false]
                setJourneyBlocker(blocker)
                break;

            case 2:
                blocker = [false, true, false]
                setJourneyBlocker(blocker)
                break;

            case 3:
                blocker = [false, false, true]
                setJourneyBlocker(blocker)
                break;

            case 4:
                blocker = [true, true, true]
                setJourneyBlocker(blocker)
                break;

            default:
                blocker = [false, false, false]
                setJourneyBlocker(blocker)
                break;
        }

        //journeySaver()
    }, [journey])

    // avoids double clicks/taps on "cancel all" with a 3s buffer
    useEffect(() => {
        if (timerBlocked) {
            var timer = { count: 3 }
            var start = setInterval(function (timer) {
                if (timer.count == 0) {
                    clearInterval(start)
                    setTimerBlocked(false)
                }
                //console.log("+++", timer.count)
                setTimerCount(timer.count)
                timer.count--
            }, 1000, timer)
        }
    }, [timerBlocked])

    /*useEffect(() => {
        console.log(context.endOfMission, journey)
        if (context.endOfMission && context.selectedRobot) {
            cancelActions({ stopAll: true })
            context.actions.setCurrentMission(null)

            if (journey === 7) {
                console.log('follow ended')
                stopMission()
            }

            if (journey > 3 && journey !== 7) {
                console.log('follow ended')
                setJourney(journey - 3)
                context.actions.setJourney(journey - 3)
                setTimeout(journeyEntrance, 10000)
            }

            if (journey === 2) {
                if (inceptionRef.current) {
                    console.log(counter)
                    if (counter < 2) {
                        setCounter(counter + 1)
                        secTimer.current = setTimeout(journeyFL, 600000)
                    } else if (counter === 2) {
                        setCounter(0)
                        secTimer.current = setTimeout(journeyEntrance, 600000)
                    } else {
                        journeyEntrance()
                        mainTimer.current = setTimeout(journeyEntrance, 1800000)
                    }
                } else {
                    mainTimer.current = setTimeout(journeyEntrance, 1800000)
                }
            }
            if (journey === 1 || journey === 3) {
                mainTimer.current = setTimeout(journeyFL, 600000)
            }
        } else {
            clearTimeout(secTimer.current)
        }
    }, [context.endOfMission])*/

    /*const journeySaver = async () => {
        if (firstRun) {
            firstRun.current = false
        } else {
            console.log(journey)
            sendJourney(journey)
        }
    }*/

    // start task
    const startTask = (mission) => {
        if (mission) {
            sendTaskToRobot({ actions: mission.actions, id: mission.name, name: mission.name })
            context.actions.setCurrentMission(mission)
            context.actions.setMessage({ message: "Missão iniciada!", type: "success" })
            console.log('publishing mission: ', { actions: mission.actions, id: mission.name, name: mission.name })
        }
    }

    // not here anymore! check ModalLocate.jsx
    const execLocation = () => {
        sendTaskToRobot({ actions: [{ value: "Base", name: "publish-pose" }], id: "Base", name: "Locate" })
        context.actions.setMessage({ message: "Localizado!", type: "success" })
    }

    const goCharge = () => {
        cancelActions({ stopAll: true })
        clearTimeout(mainTimer.current)
        clearTimeout(secTimer.current)
        context.actions.setJourney(0)
        positionRef.current = ''

        let string = {
            "robot": "FoodLab",
            "mapIndex": 0,
            "name": "Charge",
            "actions": [
                {
                    "id": "go-to",
                    "name": "go-to",
                    "needsValue": true,
                    "value": "FL_CH"
                },
                {
                    "id": "orientate-to",
                    "name": "orientate-to",
                    "needsValue": true,
                    "value": "FL_CH_ORIENTATE"
                }
            ],
        }

        startTask(string)
    }

    // all done by the robot now.
    const journeyFL = async () => {
        console.log(interactionRef.current)
        followFlag.current = false
        if (!interactionRef.current) {
            console.log(positionRef.current)

            if (positionRef.current !== 'FL_A') {
                var string = {
                    "robot": "FoodLab",
                    "mapIndex": 0,
                    "name": "J1A",
                    "actions": [
                        {
                            "id": "go-to",
                            "name": "go-to",
                            "needsValue": true,
                            "value": "FL_A"
                        },
                        {
                            "id": "orientate-to",
                            "name": "orientate-to",
                            "needsValue": true,
                            "value": "FL_A_ORIENTATE"
                        }
                    ]
                }

                positionRef.current = 'FL_A'
                startTask(string)
            } else {
                var string = {
                    "robot": "FoodLab",
                    "mapIndex": 0,
                    "name": "J1B",
                    "actions": [
                        {
                            "id": "go-to",
                            "name": "go-to",
                            "needsValue": true,
                            "value": "FL_B"
                        },
                        {
                            "id": "orientate-to",
                            "name": "orientate-to",
                            "needsValue": true,
                            "value": "FL_B_ORIENTATE"
                        }
                    ]
                }

                positionRef.current = 'FL_B'
                startTask(string)
            }
        } else {
            setTimeout(journeyFL, 5000)
        }
    }

    // all done by the robot now.
    const journeyEntrance = async () => {
        console.log(interactionRef.current)
        followFlag.current = false
        if (!interactionRef.current) {
            console.log(positionRef.current)

            if (positionRef.current !== 'FL_C') {
                inceptionRef.current = false

                var string = {
                    "robot": "FoodLab",
                    "mapIndex": 0,
                    "name": "J2A",
                    "actions": [
                        {
                            "id": "go-to",
                            "name": "go-to",
                            "needsValue": true,
                            "value": "FL_C"
                        },
                        {
                            "id": "orientate-to",
                            "name": "orientate-to",
                            "needsValue": true,
                            "value": "FL_C_ORIENTATE"
                        }
                    ]
                }

                positionRef.current = 'FL_C'
                startTask(string)
            } else {
                journeyFL()
                inceptionRef.current = true
            }
        } else {
            setTimeout(journeyEntrance, 5000)
        }
    }

    // publish what journey was changed into and save value locally
    // JOURNEYS EXPLAINED:
    // 0 - IDLE STATE/CANCEL ALL
    // 1, 2 & 3 - NORMAL FUNCTIONING MODES (LOOPS)
    // 4 - GO TO CHARGING POINT
    // 5 - FOLLOW TO FOOD LAB BUTTON (INTERRUPTING ANY MODE IN BETWEEN)
    const execJourney = (journeyNum) => {
        //setJourney(journeyNum)
        sendJourney({ data: journeyNum })

        /*context.actions.setJourney(journeyNum)

        cancelActions({ stopAll: true })
        clearTimeout(mainTimer.current)
        clearTimeout(secTimer.current)
        context.actions.setCurrentMission(null)*/

        context.actions.setMessage({ message: "Jornada iniciada: " + journeyNum, type: "success" })

        /*switch (journeyNum) {
            case 1:
            case 3:
                journeyFL()
                break;

            case 2:
                journeyEntrance()
                break;

            default:
                break;
        }*/
    }

    // publish journey = 0 and save it locally
    const stopMission = async () => {
        //setJourney(0)
        sendJourney({ data: 0 })
        /*setTimerBlocked(true)

        clearTimeout(mainTimer.current)
        clearTimeout(secTimer.current)

        positionRef.current = ''

        cancelActions({ stopAll: true })
        context.actions.setCurrentMission(null)*/

        context.actions.setMessage({ message: "Missão parada!", type: "success" })
    }

    //console.log(journeyBlocker)



    return (
        <div style={{ width: '100%' }}>
            <button disabled={journeyBlocker[0]} className="button is-outlined is-link mr-2 mb-2" onClick={() => execJourney(1)}>
                <FontAwesomeIcon icon={faPlay} className="is-small mr-1" />
                Food Lab
            </button>

            <button disabled={journeyBlocker[1]} className="button is-outlined is-link mr-2 mb-2" onClick={() => execJourney(2)}>
                <FontAwesomeIcon icon={faPlay} className="is-small mr-1" />
                Store Entrance
            </button>

            <button disabled={journeyBlocker[2]} className="button is-outlined is-link mr-2 mb-2" onClick={() => execJourney(3)}>
                <FontAwesomeIcon icon={faPlay} className="is-small mr-1" />
                Food Sampling
            </button>

            <button
                disabled={timerBlocked}
                onClick={stopMission}
                className="button is-danger mb-5 mr-3"
                style={{ float: 'right' }}
            >
                <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
                Stop All
            </button>

            <button
                disabled={!context.endOfMission}
                onClick={() => {
                    context.actions.setModalState({ ...context.modalState, locate: true })
                    console.log(context.modalState)
                }}
                //onClick={execLocation}
                className="button is-info mb-5 mr-3"
                style={{ float: 'right' }}
            >
                <FontAwesomeIcon icon={faCompass} className="is-small mr-1" />
                Locate Robot
            </button>

            <button
                className={
                    selectedMenu === "manual"
                        ? "button has-background-light is-active mb-2 mr-2"
                        : "button is-link mb-5 mr-3"
                }
                onClick={() => setSelectedMenu("manual")}
                style={{ float: 'right' }}
            >
                <FontAwesomeIcon icon={faGamepad} className="is-small mr-1" />
                Manual
            </button>

            <button className="button is-outlined is-link mr-2 mb-2" onClick={() => execJourney(4)} style={{ float: 'right' }}>
                <FontAwesomeIcon icon={faPlay} className="is-small mr-1" />
                Charge
            </button>


            <div className="panel">

                {journey === 1 &&
                    <div style={{ fontSize: 40 }}>
                        Executing - Journey 1 (Food Lab)
                    </div>
                }

                {journey === 2 &&
                    <div style={{ fontSize: 40 }}>
                        Executing - Journey 2 (Store Entrance)
                    </div>
                }

                {journey === 3 &&
                    <div style={{ fontSize: 40 }}>
                        Executing - Journey 3 (Food Sampling)
                    </div>
                }

                {journey === 4 && !context.endOfMission &&
                    <div style={{ fontSize: 40 }}>
                        Going to charging point
                    </div>
                }

                {journey > 4 && journey < 8 &&
                    <div style={{ fontSize: 40 }}>
                        Going to Food Lab
                    </div>
                }

                {people > 0 &&
                    <div style={{ fontSize: 40 }}>
                        Interacting
                    </div>
                }

                {selectedMenu === "manual" && !context.modalState.configuration ?
                    <JoystickManual />
                    : selectedMenu === "foodLabMenu" ?
                        <FoodLabMenu />
                        : ""
                }

                <ShowMessage />
            </div>
        </div>
    )

}
